import { Container } from '@mui/material';
import { Footer, Header } from 'components/templates';
import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useLoginRefresh } from 'utils/hooks';

export const LoggedInViewWrapper = () => {
  const { refresh, toggle } = useLoginRefresh();

  useEffect(() => {
    if (refresh) {
      toggle();
      window.location.reload();
    }
  }, [refresh]);

  return (
    <>
      <Header />
      <Container
        component="main"
        maxWidth="xl"
        sx={{ marginTop: '7rem', marginBottom: '7rem' }}
      >
        <Outlet />
      </Container>
      <Footer />
    </>
  );
};
